// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Amap from '@amap/amap-jsapi-loader'
import 'element-ui/lib/theme-chalk/index.css';


Vue.config.productionTip = false

// vue - 国际化
import VueI18n from 'vue-i18n';
import cookie from 'js-cookie';
import i18n from './assets/language/index'
Vue.use(VueI18n);
Vue.prototype.cookie = cookie;

// 设置 cookie 工具函数
Vue.prototype.set_cookie = (name, data, expires) => {
  cookie.set(name, data, {
    expires: expires
  })
}

// const i18n = {
//   locale: cookie.get('lang') || 'zh', // 语言标识,第一次登录默认是中文
//   messages: {
//     zh: require('./assets/language/local_zn'), // 汉语
//     en: require('./assets/language/local_en'), // 英语
//   }
// }

import url from './api/api.js' // api请求
Vue.prototype.$http = url

Vue.prototype.changeTime = function (strtime) {

  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var month = day * 30;

  var time1 = new Date().getTime();//当前的时间戳
  var time2 = new Date(strtime.replace(/-/g, '/'));

  // var time2 = stringTime*1000;//指定时间的时间戳
  var time = time1 - time2;

  // console.log("time",time);
  var result = null;
  if (time / month >= 1) {
    // result = parseInt(time/month) + "月前！";
    // console.log("strtime",strtime);
    result = strtime.split(" ")[0]
  } else if (time / week >= 1) {
    // result = parseInt(time/week) + "周前！";
    // console.log("strtime",strtime);
    result = strtime.split(" ")[0]
  } else if (time / day >= 1) {
    // result = parseInt(time/day) + "天前！";
    // console.log("strtime",strtime);
    result = strtime.split(" ")[0]
  } else if (time / hour >= 1) {
    result = parseInt(time / hour) + "小时前";

  } else if (time / minute >= 1) {
    result = parseInt(time / minute) + "分钟前";
  } else {
    result = "刚刚发布";
  }
  // console.log("result",result);
  return result;

} 
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

function setCookie(c_name) {
  var exdate = Date.now();
  document.cookie = c_name + "=" + exdate
}

Vue.prototype.getCookies = function (){
  let cookie = getCookie("cookie")
      if(cookie == null || cookie == ""){
         setCookie("cookie")
         cookie = that.getCookie("cookie")
      }
      return cookie
}


// Vue.prototype.getCookie = function (name) {
//   var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
//   if (arr = document.cookie.match(reg))
//     return (arr[2]);
//   else
//     return null;
// }

// Vue.prototype.setCookie = function (c_name) {
//   var exdate = Date.now();
//   document.cookie = c_name + "=" + exdate
// }
// 引入Vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
// import { SwipeCell } from 'vant';
// Vue.use(SwipeCell);
// import { Sidebar, SidebarItem } from 'vant';



// moment
import * as moment from 'moment'

Vue.prototype.$moment = moment

// Meta
import Meta from 'vue-meta';
Vue.use(Meta);
Vue.config.productionTip = false;

// vue-quill-editor
// import VueQuillEditor from 'vue-quill-editor'
// Vue.use(VueQuillEditor)

// router.beforeEach((to, from, next) => {
//     if (to.meta.metaInfo)
//         store.commit("CAHNGE_META_INFO", to.meta.metaInfo)
//     next()
// });

// new Vue({
//     router,
//     store,
//     metaInfo(){
//         return {
//             title: this.$store.state.metaInfo.title,
//             meta: [
//                 {
//                     name: "keywords",
//                     content: this.$store.state.metaInfo.keywords
//                 }, {
//                     name: "description",
//                     content: this.$store.state.metaInfo.description
//                 }
//             ]
//         }
//     },
//     render: function (h) {
//         return h(App)
//     }
// }).$mount('#app')

// 判断手机还是pc
Vue.prototype.$equipment = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

Vue.use(ElementUI);
Vue.use(Amap)
// 引入页面scss
import './style/style.scss';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n, // 把 i18n 挂载在全局上
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js